import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <div className="relative w-12 h-12">
        <div className="absolute w-full h-full border-4 border-[#2A382A]/20 rounded-full" />
        <div className="absolute w-full h-full border-4 border-[#E85C0D] rounded-full border-t-transparent animate-spin" />
      </div>
      <p className="text-[#2A382A]/70 text-sm font-medium animate-pulse">
        Loading...
      </p>
    </div>
  );
};

export default LoadingSpinner;